import { render, staticRenderFns } from "./TopBarMediaControls.vue?vue&type=template&id=403e05af&scoped=true"
import script from "./TopBarMediaControls.vue?vue&type=script&lang=js"
export * from "./TopBarMediaControls.vue?vue&type=script&lang=js"
import style0 from "./TopBarMediaControls.vue?vue&type=style&index=0&id=403e05af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403e05af",
  null
  
)

export default component.exports